import React from 'react';
import CaseList from '../CaseList';
import styles from './../CaseList.module.scss';
import useCases from '../../../Hooks/useCases';
import { useLazyNurseCasesQuery } from '../../../../../graphql/graphql';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import NurseCasesFilter from './NurseCasesFilter';
import CaseListItem from '../CaseListItem';
import useSocket from '../../../../Base/Hooks/useSocket';
import { Socket } from '../../../../Base/Enums/Socket.enum';

const NurseCasesList: React.FC = () => {
	const [getNurseCasesQuery, { data, isLoading }] = useLazyNurseCasesQuery();
	const { getWorkplaceCases, getNextPage, page, setPage } =
		useCases(getNurseCasesQuery);

	const {
		flatData,
		hasMoreData,
		loadData,
		setFilter,
		isLoading: isFlatDataLoading,
	} = useFlatData(
		getWorkplaceCases,
		{
			data: data?.nurseCases?.data,
			totalPages: data?.nurseCases?.meta?.totalPages,
			page: data?.nurseCases?.meta?.page,
		},
		page,
		setPage,
	);

	useSocket(Socket.CASE_TAKEN, loadData);

	return (
		<div className={styles.wrapper}>
			<NurseCasesFilter onFilter={setFilter} />
			<CaseList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={() => loadData(true)}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				isFlatDataLoading={isFlatDataLoading}
				renderItem={item => (
					<CaseListItem
						item={item}
						onRefresh={() => loadData(true)}
						showWorkplace
						showAssignedDoctor
					/>
				)}
			/>
		</div>
	);
};

export default NurseCasesList;
